import { SendingTypes } from '@sigmasms/shared-types'

export const allowedSendingTypesForImage = [
  SendingTypes.viber,
  SendingTypes.whatsapp
]
